import { z } from 'zod';

const cessionFiltersSchema = z.object({
  date_end: z.string().optional(),
  date_start: z.string().optional(),
  search_query: z.string().optional(),
  search_type: z.string().optional(),
  status: z.string().optional(),
  type: z.string().optional(),
}).refine(
  (data) => {
    if (data.date_start && data.date_end) {
      return new Date(data.date_start) <= new Date(data.date_end);
    }
    return true;
  },
  {
    message: 'Data de início deve ser menor ou igual à data de fim',
    path: ['date_end'],
  },
);

export default cessionFiltersSchema;
export type CessionFiltersFormData = z.infer<typeof cessionFiltersSchema>;
